// Lib
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Types
import Candidate from 'types/candidates';

// Hooks
import useModal from 'hooks/useModal';

// Actions
import { getCandidateNote } from 'selectors/candidates';
import { moveCandidateToStage, rejectUserCandidate, removeRecruiterCandidate } from '../actions';

const useJobBoardCandidate = (jobId: number, candidate: Candidate) => {
  const dispatch = useDispatch();

  const stages = useSelector<any, any>(state => state.jobBoard.stages);

  const currentStage = stages.find((stage: any) => stage.id === candidate.stageId);

  const { openModalHandler, closeModalHandler } = useModal();

  const moveUserCandidatesHandler = useCallback(
    (stageId: number, stageTitle: string) => () => {
      if (stageTitle === 'Placement') {
        return openModalHandler({
          title: 'attachFile',
          data: {
            label: 'Please, attach your Job offer',
            attachedFileType: 'unsigned-offer',
            attachedFilePropName: 'unsignedOfferUrl',
            stageId,
            stageTitle,
            candidateId: candidate.id,
          },
        })();
      }
      return dispatch(
        moveCandidateToStage({ jobId, stageId, stageTitle, candidateId: candidate.id })
      );
    },
    [dispatch, jobId, candidate.id, openModalHandler]
  );

  const rejectUserCandidateHandler = useCallback(
    (event: Event) => {
      event.preventDefault();
      const { currentTarget }: any = event;

      dispatch(
        rejectUserCandidate({
          jobId,
          candidate,
          rejectReason: currentTarget.notes.value,
        })
      );

      dispatch(closeModalHandler());
    },
    [dispatch, jobId, candidate, closeModalHandler]
  );

  const removeRecruiterCandidateHandler = useCallback(
    () => dispatch(removeRecruiterCandidate({ id: candidate.id, jobId })),
    [dispatch, candidate.id, jobId]
  );

  const candidateNote = useSelector<any, any>(state => getCandidateNote(state, candidate.id));

  return {
    moveUserCandidatesHandler,
    rejectUserCandidateHandler,
    removeRecruiterCandidateHandler,
    stages,
    currentStage,
    candidateNote,
  };
};

export default useJobBoardCandidate;
